import { React, useState, useEffect } from "react";
import { QuestionOutlined } from '@ant-design/icons';
import { Button, Popover, Typography, Collapse, Modal } from 'antd';
import { Link } from "react-router-dom";
import ReactPlayer from 'react-player';
import '../../Styles/styles-misc.css';
import { useSelector } from "react-redux";
import { TrainingAPI } from "../../api/TrainingAPI";
import { audioMessage as message } from './Notifications/audioMessage';

const { Title } = Typography;

export const HelpButton = ({ page = "Overview", extraContent=undefined }) => {
    const { misc: { help_center_videos }, info: { display_name } } = useSelector(({ team }) => team);
    const pageVideos = (help_center_videos || []).filter(video => video.category === page);
    const [open, setOpen] = useState(false);
    const [activePanel, setActivePanel] = useState(undefined);
    const [videoPlayerIsOpen, setVideoPlayerIsOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState(undefined);
    const trainingAPI = new TrainingAPI();

    const VideoPlayerModal = () => {
        return (
            <div style={{ border: '1px solid black' }} onContextMenu={(event) => event?.preventDefault()}>
                <ReactPlayer
                    src={videoUrl}
                    controls
                    controlsList="nodownload"
                    width='100%'
                    height='100%'
                    playing={true}
                />
            </div>
        );
    };

    const handleClick = (video_key) => {
        setOpen(false);
        trainingAPI.getHelpVideoUrl(video_key).then((response) => {
            setVideoUrl(response.presigned_url);
            setVideoPlayerIsOpen(true);
        }).catch(() => {
            message.error('Error loading video. Please try again later.');
        });
    };

    const onPanelChange = (key) => {
        setActivePanel(key);
        setVideoPlayerIsOpen(false);
    };

    const popoverContent = (
        <>
            {extraContent}
            <div>
                <Title level={5}>Here are some videos to help you navigate this page.<br />
                    For more videos, check out the <Link to="/help-center">Help Center</Link>
                </Title>
            </div>
            <div>
                <Collapse accordion activeKey={activePanel} destroyInactivePanel onChange={onPanelChange}>
                    {pageVideos.map((video) => (
                        <Collapse.Panel header={video.title} key={video.key}>
                            <Button onClick={() => handleClick(video.key)}>Play Video</Button>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </>
    );

    return (
        <>
            {pageVideos.length === 0 ? null : (
                <>
                    <Modal
                        open={videoPlayerIsOpen}
                        footer={null}
                        onCancel={() => { setVideoPlayerIsOpen(false); setVideoUrl(undefined); }}
                        closable={false}
                        width={'75vw'}
                        destroyOnHidden
                        styles={{
                            mask: {
                                backdropFilter: 'blur(10px)'
                            }
                        }}
                        bodyStyle={{ padding: 10 }}
                    >
                        <VideoPlayerModal />
                    </Modal>
                    <Popover
                        content={popoverContent}
                        title="Help me!"
                        trigger="click"
                        open={open}
                        placement="topRight"
                    >
                        <Button
                            type="primary"
                            shape="circle"
                            size="large"
                            className="help-button"
                            icon={<QuestionOutlined style={{ fontSize: 24 }} />}
                            onClick={() => setOpen(!open)}
                        />
                    </Popover>
                </>
            )}
        </>
    );
};

export default HelpButton;